import React, { useState, useRef, useEffect } from "react";
import marked from "marked";
import MuiMarkupTableWrap from "components/global/MuiMarkupTableWrap";
import QuoteCTA from "components/QuoteCTA";
// mui
import { useTheme } from "@mui/styles";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import ButtonBase from "@mui/material/ButtonBase";
// utils
import generateRateTable from "lib/generateRateTable";

export default function QuoteTeaser({ capitalData, url, postData }) {
  const content = marked(capitalData?.Body);

  const [domLoaded, setDomLoaded] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    setDomLoaded(true);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        margin: theme.spacing(5, 3, 10, 3),
        textDecoration: "none !important",
        color: "inherit !important",
      }}
    >
      <MuiMarkupTableWrap>
        <Paper elevation={3}>{domLoaded && generateRateTable(content)}</Paper>
      </MuiMarkupTableWrap>
      <Box
        sx={{
          width: "50%",
          margin: theme.spacing(4, "auto", 0, "auto"),
          [theme.breakpoints.down("md")]: { margin: 0, width: "100%" },
        }}
      >
        <QuoteCTA postData={postData} scrollID={"quote_teaser"} />
      </Box>
    </Box>
  );
}
